<template>
  <div>
    <h2 v-if="error">{{ error }}</h2>
    <h1 v-if="meditation && !error">
      {{ meditation.title }}
    </h1>
    <hr v-if="meditation">
    <h4 v-if="meditation">
      Read {{ meditation.verse }}
    </h4>
    <hr>
    <div v-if="meditation" v-html="meditation.content" />
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';

const data = 'Meditations';

export default {
    // data() {
    //     return { title: 'Show a Meditation' };
    // },
    // computed: {
    //     id() {
    //         return this.$route.params.id;
    //     }
    // }
    data() {
        return {
            title: 'MeditationShow',
            namespace: 'Meditations'
        };
    },
    computed: {
        ...mapState({
            meditation: (state) => state.Meditations.meditation,
            error: (state) => state.Meditations.error,
        })
    },
    methods: {
        // i dont know what this is, but russell had it
        // getIdFromIndex(index) {
        //     return this.plans[index].id;
        // },
        getMeditationById() {
            this.$store.dispatch(`${this.namespace}/getMeditationById`,
                { meditationId: this.$route.params.id });
        },

    },
    created() {
        this.getMeditationById();
        this.$store.commit('Meditations/setError', '');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>
